import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";

export { Tooltip } from "./Tooltip";
export { TooltipArrow } from "./TooltipArrow";
export { TooltipContent } from "./TooltipContent";
export { TooltipPortal } from "./TooltipPortal";
export { TooltipProvider } from "./TooltipProvider";
export { TooltipTrigger } from "./TooltipTrigger";
export { TooltipViewport } from "./TooltipViewport";

export type * from "./Tooltip.types";

export { tooltipDataSchema, type TooltipDataProps } from "./Tooltip.schema";

export const createTooltipHandle = BaseTooltip.createHandle;
